import React, {Component} from "react";
import "./index.css";
import { withRouter } from "react-router-dom";
import ClubRoutes from "./routes/ClubRoutes";
import ShopRoutes from "./routes/ShopRoutes";
import ComRoutes from "./routes/ComRoutes";


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
    this.shell = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // The shell is the scroll container, so resetting the window alone is not enough.
      window.scrollTo(0, 0);
      if (this.shell.current) this.shell.current.scrollTop = 0;
    }
  }

  render() {
    return (
        <div
            ref={this.shell}
            style={{
                width: '100dvw',
                height: '100dvh',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}
        >
            <DomainRouter/>
        </div>
    );
  }
}

App = withRouter(App);

export default App;

const DomainRouter = () => {
    const host = window.location.hostname;

    if (host.includes("schmodel.club")) {
        return <ClubRoutes />;
    }
    if (host.includes("schmodel.shop")) {
        return <ShopRoutes />;
    }
    return <ComRoutes />;
}
